import { EnvironmentProviders, Injectable, Provider } from "@angular/core";
import { PricelistsRoutesProvider } from "./lib/routes/pricelists.routes";

@Injectable({ providedIn: 'root' })
export class PricelistsConfigService {
    constructor() {}
}

export const providePricelists = (): Array<Provider | EnvironmentProviders> => {
    return [
        { provide: PricelistsRoutesProvider.getToken(), useClass: PricelistsRoutesProvider, multi: true },
    ];
}